import { createSelector } from "reselect";
import _ from "lodash";

const getCustomNotes = (visits) => {
  const res = {};
  _.forEach(_.keys(visits), (id) => {
    const customNotes = visits[id]?.location?.customNotes || {};
    _.forEach(_.keys(customNotes), (label) => {
      res[label] = res[label] || {};
      res[label][id] = customNotes[label].toString();
    });
  });
  return res;
};

const csvDataSelector = createSelector(
  (state) => state.jobReducer.data,
  (state) => state.filterReducer.fleetIds,
  (data, fleetIds) => {
    const results = [];
    const headers = [
      "Fleet",
      "#",
      "Type",
      "Arrival Time",
      "Finish Time",
      "Address",
      "Latitude",
      "Longitude",
    ];
    if (
      !data.input ||
      !data.network ||
      !data.input.fleet ||
      !data.output.solution
    ) {
      return [headers];
    }

    const {
      input,
      network,
      output: { solution, unserved },
    } = data;

    const customNotes = getCustomNotes(input.visits);
    _.forEach(_.keys(customNotes), (label) => {
      headers.push(label);
    });
    results.push(headers);

    let vSolution = [];
    Object.keys(solution).forEach((vehicleId) => {
      if (fleetIds.indexOf(vehicleId) > -1) {
        vSolution = solution[vehicleId];
        vSolution.forEach((vs) => {
          const vNetwork =
            network[vs.location_id] || network[`${vs.location_id}_${vs.type}`];

          if (vNetwork && vNetwork.lat && vNetwork.lng) {
            const row = [
              vehicleId,
              vs.location_id,
              vs.type,
              vs.arrival_time,
              vs.finish_time,
              vs.address || vs.location_name,
              vNetwork.lat,
              vNetwork.lng,
            ];
            _.forEach(_.keys(customNotes), (label) => {
              row.push(customNotes[label][vs.location_id] || "");
            });
            results.push(row);
          }
        });
      }
    });

    if (!!unserved) {
      Object.keys(unserved).forEach((visitId) => {
        const vNetwork = network[visitId] || network[`${visitId}_pickup`] || {};

        if (!!vNetwork) {
          const row = [
            "unserved",
            visitId,
            "",
            "",
            "",
            vNetwork.name,
            vNetwork.lat,
            vNetwork.lng,
          ];
          _.forEach(_.keys(customNotes), (label) => {
            row.push(customNotes[label][visitId] || "");
          });
          results.push(row);
        }
      });
    }

    return results;
  }
);

export default csvDataSelector;
